module.exports = __webpack_public_path__ + "media/images/thumb/no_image-31c0dcc60a6cd9e0ac1c94fcd9881c38.gif";